import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Apis from './apis';
import { IAppState } from '@/app-state';
import { ISearchOrderVerificationDetailsResponse } from './interfaces/po-response';
import { BucketTypes } from '@/app-constants';

export const getRequest = (state: IAppState) => state.poListState.request;

export function* poListSaga() {
  const request = yield select(getRequest);

  Apis.saveUserDefinedFilters(request.filters);

  try {
    const response: ISearchOrderVerificationDetailsResponse = yield call(Apis.searchOrderVerificationDetails, request);
    const { buckets, flaggedConversationCount, unreadMessageCount, filterCategories, orderVerificationDetails } = response;
    const expectedIds = Object.keys(BucketTypes).map(id => +BucketTypes[id]);
    const expectedBuckets = buckets.filter(bucket => expectedIds.some(id => id === bucket.id));
    const successPayload = {
      flaggedConversationCount,
      unreadMessageCount,
      buckets: expectedBuckets,
      avaliableFilters: filterCategories,
      purchaseOrders: orderVerificationDetails.items,
      offset: orderVerificationDetails.offset,
      total: orderVerificationDetails.total
    };
    yield put(Actions.poListSuccessAction(successPayload));
  } catch (error) {
    yield put(Actions.poListFailureAction(error));
  }
}

export function* watchPoListSaga() {
  yield takeLatest(Actions.PO_LIST_ACTIONS.REQUEST, poListSaga);
}
